import utils from '../../utils/tag-name';
import { ICON_NAME } from '../checkbox/checkbox.constants';

const TAG_NAME = utils.constructTagName('staticcheckbox');

export { TAG_NAME, ICON_NAME };
